<section class="profile-page">
  <mat-card class="profile-card">
    @if (profileError) {
    <p class="profile-error">{{ profileError }}</p>
    }

    <div class="profile-header">
      <div class="profile-avatar">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div>
        <p class="eyebrow">Admin Profile</p>
        <h1>{{ (currentUser?.username || 'Admin User') | titlecase }}</h1>
        <p class="subtitle">{{ isLoading ? 'Refreshing profile...' : 'Manage your account and session.' }}</p>
      </div>
    </div>

    <div class="profile-grid">
      <div class="profile-item">
        <span class="label">Username</span>
        <span class="value">{{ (currentUser?.username || 'NA') | titlecase }}</span>
      </div>
      <div class="profile-item">
        <span class="label">Role</span>
        <span class="value">{{ currentUser?.role || 'NA' }}</span>
      </div>
      <div class="profile-item">
        <span class="label">Status</span>
        <span class="value">{{ currentUser?.isActive === false ? 'Inactive' : 'Active' }}</span>
      </div>
      <div class="profile-item">
        <span class="label">Last Login</span>
        <span class="value">{{ currentUser?.lastLoginAt ? (currentUser?.lastLoginAt | date:'medium') : 'NA' }}</span>
      </div>
    </div>

    <div class="profile-actions">
      <button mat-stroked-button color="primary" type="button" routerLink="/dashboard">
        Back To Dashboard
      </button>
      <button mat-raised-button color="warn" type="button" (click)="logout()">
        Logout
      </button>
    </div>
  </mat-card>
</section>
